import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UccxFieldConfig } from '../../../../shared/models/generated/ziroModels';

@Injectable()
export class UccxAgentFieldConfigResource {
  private http = inject(HttpClient);

  getFieldConfigs(uccxServerId: number): Observable<UccxFieldConfig> {
    return this.http.get<UccxFieldConfig>(`/services/cisco/field-configs/uccx-agents?uccx-server-id=${uccxServerId}`);
  }
}
